import xss from "xss";
import CONFIG from "../../config";
import RESPONSE_HEADER from "../enums/RESPONSE_HEADER";

export function getErrorResponseMessage(response) {
  if (!response || !response.config) return "unbekannter Fehler";
  return response.config.method !== "post" ? getErrorResponseMessageForGet(response) : getErrorResponseMessageForPost(response);
}

export function getErrorResponseMessageForGet(response) {
  if (!response || !response.request) {
    return `Fehler: Konnte Daten nicht laden`;
  }
  if (response.status >= 400) {
    return `Fehler: Konnte "${response.request.responseURL}" nicht laden`;
  }

  if (!response.data) {
    return `Fehler: Das Laden der Daten "${response.request.responseURL}" lieferte kein Ergebnis.`;
  }

  let message = "";
  if (response.data && response.data.header && response.data.header.errorNr) {
    message += (" " + xss(response.data.header.errorNr));
  }
  if (response.data && response.data.header && response.data.header.errorMsg) {
    message += (": " + xss(response.data.header.errorMsg));
  }
  return message || "e13: Ein Übertragungsfehler ist aufgetreten";
}

export function getErrorResponseMessageForPost(response) {
  if (!response || !response.request) {
    return `Fehler: Konnte Daten nicht laden`;
  }
  if (response.status >= 400) {
    return `Fehler: Konnte "${response.request.responseURL}" nicht aktualisieren`;
  }

  let message = "";
  if (response.data && response.data.header && response.data.header.errorNr) {
    message += (" " + xss(response.data.header.errorNr));
  }
  if (response.data && response.data.header && response.data.header.errorMsg) {
    message += (": " + xss(response.data.header.errorMsg));
  }
  return message
    ? `Fehler: Das Aktualisieren der Daten "${response.request.responseURL}" lieferte kein Ergebnis`
    : "e14: Ein Übertragungsfehler ist aufgetreten";
}

export function checkAllResponses(responses) {
  let messages = [];
  if (Array.isArray(responses)) {
    messages = responses.filter(isResponseWrong).map(getErrorResponseMessage).filter(m => !!m);
  }
  return {
    "status": (messages.length === 0 ? "OK" : "ERROR"),
    "message": messages.join(", ")
  };
}

export function isResponseWrong(response) {
  if (!response || !response.config) return false;
  if (response.config.method === "get" || response.config.method === "put") {
    return !response.data;
  }
  if (
    response.data &&
    response.data.header &&
    response.data.header.status &&
    (
      response.data.header.status === "OK" ||
      response.data.header.status === "INFO" ||
      response.data.header.status === "SUCCESS" ||
      response.data.header.status === RESPONSE_HEADER.STATUS.DELTA
    )
  ) {
    return false;
  }
  return true;
}

export function checkDeltaResponse(response) {
  if (response && response.data && response.data.header) {
    let deltaList = CONFIG.getShopConfig({
      edelmetall: "listEdelmetallWarenkorbDelta",
      sorten: "listSortenWarenkorbDelta"
    });
    const errorKey = "E" + response.data.header.errorNr;
    if (Array.isArray(response.data[deltaList]) && response.data[deltaList].length === 0) {
      return {
        status: RESPONSE_HEADER.DELTA_STATUS[errorKey] || response.data.header.errorNr,
        message: RESPONSE_HEADER.DELTA_ERROR.SUMME
      };
    }
    if (response.data.header.errorNr) {
      return {
        status: RESPONSE_HEADER.DELTA_STATUS[errorKey] || response.data.header.errorNr,
        message: RESPONSE_HEADER.DELTA_ERROR[errorKey] || "Fehler bei der Überprüfung des Warenkorbs"
      };
    }
    return {
      status: "OK"
    };
  }
  return {
    status: "ERROR",
    message: "Fehler bei der Überprüfung des Warenkorbs"
  };
}
